var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-pill p-1 px-2 text-center",class:`bg-${_vm.statusSet[_vm.status].color}`},[_c('span',{staticClass:"fw-bold",class:`text-${_vm.statusSet[_vm.status].contrast}`},[_vm._v(_vm._s(_vm.statusSet[_vm.status].name)+_vm._s(_vm.isActive ? '...' : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }